export const engagements = [
  { text: '0~1000', value: 'engagements:0~1000' },
  { text: '1000~5000', value: 'engagements:1000~5000' },
  { text: '5000~10000', value: 'engagements:5000~10000' },
  { text: '>10000', value: 'engagements:10000~' },
];
export const likes = [
  { text: '0~1000', value: 'likes:0~1000' },
  { text: '1000~5000', value: 'likes:1000~5000' },
  { text: '5000~10000', value: 'likes:5000~10000' },
  { text: '>10000', value: 'likes:10000~' },
];
export const comments = [
  { text: '0~500', value: 'comments:0~500' },
  { text: '500~1000', value: 'comments:500~1000' },
  { text: '>1000', value: 'comments:1000~' },
];
export const shares = [
  { text: '0~500', value: 'shares:0~500' },
  { text: '500~1000', value: 'shares:500~1000' },
  { text: '1000~10000', value: 'shares:1000~10000' },
  { text: '>10000', value: 'shares:10000~' },
];

export const targetNumMap: { [key: string]: number } = {
  engagements: engagements.length,
  likes: likes.length,
  comments: comments.length,
  shares: shares.length,
};

export const titleMapFormat: { [key: string]: string } = {
  engagements: 'Engagement',
  likes: 'Like',
  comments: 'Comment',
  shares: 'Share-2',
};
